import type { Message } from '@/features/messages';
import { chatEE } from '@/layout';
import type { Virtualizer } from '@tanstack/react-virtual';
import { useEffect } from 'react';
import { useActionStackStore } from '../stores/action-stack';

export interface UseMessageEventsOptions {
  conversationId?: Nullable<string>;
  messages: Message[];
  virtualizer: Virtualizer<HTMLDivElement, Element>;
}

export interface ZoomToMessagePayload {
  conversationId: string;
  messageId: string;
}

export function useMessageEvents() {
  const { dispatchAction } = useActionStackStore();

  useEffect(() => {
    const scrollToMessage = ({ conversationId, messageId }: ZoomToMessagePayload) => {
      if (!messageId) return;
      dispatchAction({ type: 'jumpTo', conversationId: conversationId, targetMessageId: messageId });
    };

    chatEE.on('zoom-to-message', scrollToMessage);
    return () => {
      chatEE.off('zoom-to-message', scrollToMessage);
    };
  }, []);
}
